import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/view/components/ui/dropdown-menu'
import { Button } from '@/view/components/ui/button'
import { Skeleton } from '@/view/components/ui/skeleton'
import { LineChart } from 'lucide-react'
import { Line } from 'react-chartjs-2'
import { useConsultsChartController } from './useConsultsChartController'

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  Tooltip,
  Legend,
)

export const ConsultsChart = () => {
  const {
    selected,
    selectedLabel,
    timeOptions,
    handleSelect,
    data,
    options,
    isLoading,
  } = useConsultsChartController()

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-medium">Histórico de consultas</h1>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="flex items-center gap-2">
              <LineChart className="h-4 w-4" /> {selectedLabel}
            </Button>
          </DropdownMenuTrigger>

          <DropdownMenuContent align="end">
            {timeOptions.map((option) => (
              <DropdownMenuItem
                key={option.value}
                onSelect={() => handleSelect(option.value)}
                className={`cursor-pointer px-4 py-4 ${
                  selected === option.value ? 'bg-gray-100 text-primary' : ''
                }`}
              >
                {option.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <div className="max-w-full overflow-auto">
        {isLoading ? (
          <Skeleton className="mt-4 h-[220px]" />
        ) : (
          <Line
            style={{ height: '220px', marginTop: 10 }}
            options={options}
            data={data}
          />
        )}
      </div>
    </div>
  )
}
